import { trackPromise } from 'react-promise-tracker';
import Axios from 'axios';

import api from '../api';
import { getJwt } from '@app/helpers';

import { moduloOrcado, moduloProjeto, moduloRelatorioProjeto } from '@app/helpers/modulos';

import { InformacaoProjetoResult } from '../tabelaProjetoOverView';
import { CrfPlanilhaCapexProjeto } from './crfOrcado';

const controller = 'crfProjetos';

export interface CrfProjeto {
  id: string;
  codigo: string;
  nome: string;
  numero: string;
  dataConclusao?: string;
  dataInicioBaseLine?: string;
  dataTerminoBaseLine?: string;
  escopoPluriAnual: string;
  requisitoAmbiental: string;
  plurianual?: boolean;
  valorOrcadoCapexTotal: number;
  valorOrcadoRFATotal: number;
  valorOrcadoEconomicoAnoTotal: number;
  valorOrcadoFinanceiroAnoTotal: number;
  situacao: string;
  responsavelMatricula: string;
  responsavelCentroDeCusto: string;
  dataHoraCadastroTotvs?: string;
  ultimaAtualizacaoDataHora?: string;
  ultimaAtualizacaoMatriculaResponsavel?: string;
  departamentoId?: string;
  areaId?: string;
  diretoriaId?: string;
  usuarioLiderProjetoId?: string;
  acronimoProjetoId?: string;
  statusProjetoId?: string;
  statusRfaId?: string;
  tipoProjetoFaseId?: string;
  statusNome?: string;

  dataConclusaoFormatada: string;
  dataInicioBaseLineFormatada: string;
  dataTerminoBaseLineFormatada: string;
  dataHoraCadastroTotvsFormatada: string;
  ultimaAtualizacaoDataHoraFormatada: string;

  responsavelMatriculaNome: string;
  ultimaAtualizacaoMatriculaResponsavelNome: string;
  texto_revisao: string;

  inicioBaselineDateTime?: Date;
  fimBaselineDateTime?: Date;

  inicioRealForcastDateTime?: Date;
  terminoRealForcastDateTime?: Date;

  inicioRealDateTime?: Date;
  terminoRealDateTime?: Date;

  informacaoProjetoResult?: InformacaoProjetoResult;

  inicioBaseline: any;
  fimBaseline: any;
  inicioRealForcast: any;
  terminoRealForcast: any;
  inicioReal: any;
  terminoReal: any;

  crfProjetoDisciplinaId?: string;
  crfDisciplinaProjetoNome: string;
}

export interface ProjetoCrfContaContabilCc {
  projetoId: string;
  crfContaContabilCcId: string;
  codigo: string;
  codigoPacote: string;
  numero: string;
  nome: string;
}

export interface CrfProjetoPacote {
  CodigoPacote: string;
  PacoteNome: string;
  PacoteNumero: string;
  pacoteOi: string;
  situacao: string;
  ultimaAtualizacao: string;
  possuiRfa: string;
  projetoNome: string;
  matriculaResponsavel: string;
  acronimoId: string;
  id: string;
  ordemId: string;
  index: number;
}

export interface CrfProjetoJoinPacote {
  id: string;
}

export interface CrfPlanilhaOrcadoEconomico {
  id: string;
  revisao: number;
  numero: number;
  observacao: string;
  ano: number;
  dataAprovacao: Date;
  statusPlanilha: string;
  possuiPlanilhaOrcadoEconomico?: boolean;
  tabelaPlanilhaOrcadoEconomico: any;
  momeColunasDinamicas?: string[];
  columnProps?: ColumnProps[];
}

export interface CrfDadoPlanilhaOrcadoEconomico {
  numberIndex: number;
  oi: string;
  numero: number;
  revisao: number;
  dataAprovacao: string;
  ano: number;
  mes: number;
  mesAno: string;
  valor: string;
  oiTipoInteiro?: number;
}

export interface ColumnProps {
  title: string;
  dataIndex: string;
  width: string;
}

export interface CrfPlanilhaOrcadoEconomicoFormProps {
  id?: string;
  file: any;
  numero: number;
  revisao: string;
  dataAprovacao: string;
  observacao: string;
}

export interface CrfResumoCapex {
  projetoId: string;
  numero: number;
  revisao: number;
  oi: string;
  codigoPacote: string;
  nome: string;
  valor: number;
  valorTotal: number;
  valorCurrency: string;
  valorTotalCurrency: string;
  dataAprovacao: string;
  index: number;
}

export interface CrfResumoRfa {
  projetoId: string;
  numero: number;
  revisao: number;
  oi: string;
  codigoPacote: string;
  nome: string;
  valor: number;
  valorTotal: number;
  valorCurrency: string;
  valorTotalCurrency: string;
  dataAprovacao: string;
  index: number;
}


export interface CrfResumoAnoMes {
  projetoId: string;
  numero: number;
  revisao: number;
  numeroCentroDeCusto: string;
  crfContaContabilCodigo: string;
  codigoPacote: string;
  nome: string;
  valor: number;
  valorTotal: number;
  valorTotalCurrency: string;
  valorCurrencyArray: [];
  valorTotalCurrencyArray: [];
  ano: string;
  planilhaId: string;
  index: number;
  resultDataTabel: any;
  anoArray: [];
  dataAprovacao: string;
}

export interface CrfValorTotalAno {
  valorTotalCurrency: string;
  ano: string;
  index: number;
}

export interface IRelatorioCentroDeCustoResult {
  idx: string;
  projetoNumero: string;
  projetoCodigo: string;
  projetoNome: string;
  codigoContaContabil: string;
  nomeContaContabil: string;
  codigoAgrupador: string;
  situacao: string;
  rfa: string;
  data: string;
  siglaDiretoria: string;
  siglaArea: string;
  siglaDepartamento: string;
  responsavel: string;
  crfContaContabilCcId: string;
}

export interface CrfRequisitadoRc {
  codigoPacote: string;
  nome: string;
  numero: string;
  rcStatus: string;
  valorTotalFormatado: string;
  requisicaoCompraValorTotalFormatado: string;
  crfContaContabilCcId: string;
  index: number;
  requisitadoComOrdemDeCompra: CrfRequisitadoComOrdemCompra[];
  requisitadoSemOndemDeCompra: CrfRequisitadoSemOrdemCompra[];
}

export interface CrfRequisitadoSemOrdemCompra {
  narrativa: string;
  requisicaoCompraNumero: number;
  requisicaoCompraSeq: number;
  requisicaoCompraValorTotal: string;
  requisicaoCompraValorTotalFormatado: string;
  valorParaDistribuidoFormatado: string;
  valorDistribuidoFormatado: string;
  distribuidoTotalFormatado: string;
  crfContaContabilCcId: string;
  principalFormatado: string;
  index: number;
}

export interface CrfRequisitadoComOrdemCompra {
  narrativa: string;
  requisicaoCompraNumero: number;
  requisicaoCompraSeq: number;
  requisicaoCompraValorTotal: string;
  requisicaoCompraValorTotalFormatado: string;
  valorParaDistribuidoFormatado: string;
  valorDistribuidoFormatado: string;
  distribuidoTotalFormatado: string;
  crfContaContabilCcId: string;
  principalFormatado: string;
  requisicaoCompraOc: string;
  index: number;
}

export const getAllCrfProjetos = () => api.get<CrfProjeto[]>(`${controller}`);
export const getAllCrfProjetosOptions = () =>
  getAllCrfProjetos().then(projeto => (projeto || []).map(a => ({ text: a.nome, value: a.id.toString() })));

export const getAllCrfProjetosTelaProjeto = (moduloCrFch: string) => api.get<CrfProjeto[]>(`${controller}?modulo=${moduloProjeto}&moduloCrFch=${moduloCrFch}`);
export const getAllCrfProjetosTelaRelatorioProjeto = () => api.get<CrfProjeto[]>(`${controller}?modulo=${moduloRelatorioProjeto}`);
export const getAllCrfProjetosPlanilhaCapexModulo = () => api.get<CrfProjeto[]>(`${controller}?modulo=${moduloOrcado}`);
export const getAllProjetoRelatorios = () => api.get<CrfProjeto[]>(`${controller}/getAllProjetoRelatorios`);

export const updateResponsaveisCrfProjeto = (projeto: CrfProjeto) =>
  api.put<CrfProjeto>(`${controller}/${projeto.id}/responsaveis`, projeto);

export const updateAcronimoNoCrfProjeto = (projeto: CrfProjeto) =>
  api.put<CrfProjeto>(`${controller}/${projeto.id}/acronimo`, projeto);

export const updateDadosCrfProjeto = (projeto: CrfProjeto) =>
  api.put<CrfProjeto>(`${controller}/${projeto.id}/dadosProjeto`, projeto);

export const getCrfProjetoJoinTipoPacote = (join: CrfProjetoJoinPacote) =>
  api.get<CrfProjetoPacote[]>(`${controller}/projetoJoinPacote/${join.id}`);

export const getCrfProjetoJoinAgrupador = (join: CrfProjetoJoinPacote) =>
  api.get<CrfProjetoPacote[]>(`${controller}/projetoJoinAgrupador/${join.id}`);

//#region CAPEX
export const GetAllCrfPlanilhaCapexAntigas = (projetoId: any) =>
  api.get<any[]>(`${controller}/${projetoId}/planilha/capex?filtrarAntigas=true`);

export const getAllCrfPlanilhaCapexOrcadoEconomicoCapexAnoMesResultForProjetoId = (projetoId: any) =>
  api.get<any[]>(`${controller}/${projetoId}/orcadoeconomico/capex`);

export const createPlanilhaCapex = (projetoId: string, file: any, planilhaCapex: CrfPlanilhaCapexProjeto) => {
  const form = new FormData();
  planilhaCapex.projetoId = projetoId;

  if (planilhaCapex.texto_revisao == null) {
    planilhaCapex.texto_revisao = '';
  }

  if (planilhaCapex.numero_planilha == null) {
    planilhaCapex.numero_planilha = '';
  }

  form.append('file', file);
  form.append('projetoId', projetoId);
  form.append('numero', planilhaCapex.numero_planilha);
  form.append('revisao', planilhaCapex.texto_revisao);
  form.append('dataAprovacao', String(planilhaCapex.dataAprovacao));

  return api.post(`${controller}/importacao/planilha/capex`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getAllResumoCrfPlanilhaCapexProjeto = (projetoId: any) =>
  api.get<CrfResumoCapex[]>(`${controller}/${projetoId}/planilha/capex/resumo`);
//#endregion

//#region RFA
export const GetAllCrfPlanilhaRfaAntigas = (projetoId: any) =>
  api.get<any[]>(`${controller}/${projetoId}/planilha/rfa?filtrarAntigas=true`);

export const GetAllCrfPlanilhaRfaAnoMes = (projetoId: any) =>
  api.get<any[]>(`${controller}/${projetoId}/planilha/rfaAnoMes`);

export const createCrfPlanilhaRfa = (projetoId: string, file: any, planilhaCapex: CrfPlanilhaCapexProjeto) => {
  const form = new FormData();
  planilhaCapex.projetoId = projetoId;
  if (planilhaCapex.texto_revisao == null) {
    planilhaCapex.texto_revisao = '';
  }

  if (planilhaCapex.numero_planilha == null) {
    planilhaCapex.numero_planilha = '';
  }

  form.append('file', file);
  form.append('projetoId', projetoId);
  form.append('numero', planilhaCapex.numero_planilha);
  form.append('revisao', planilhaCapex.texto_revisao);
  form.append('dataAprovacao', String(planilhaCapex.dataAprovacao));

  return api.post(`${controller}/importacao/planilha/rfa`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getAllResumoCrfPlanilhaRfaProjeto = (projetoId: any) =>
  api.get<CrfResumoRfa[]>(`${controller}/${projetoId}/planilha/rfa/resumo`);
//#endregion

//#region ECONOMICO ANUAL
export const getByIdCrfPlanilhaOrcadoEconomicoAnoMes = (id: string) =>
  api.get<CrfPlanilhaOrcadoEconomico>(`${controller}/planilha/orcadoAnual/${id}`);

export const getAllCrfPlanilhasOrcadoEconomicoAnoMes = () =>
  api.get<CrfPlanilhaOrcadoEconomico[]>(`${controller}/planilha/orcadoAnual`);

export const verificarSeExiteCrfPlanilha = (id: string) =>
  api.get<boolean>(`exportar/verificarSeExitePlanilhaCrf/${id}`);

export const createCrfPlanilhaOrcamento = (formValues: CrfPlanilhaOrcadoEconomicoFormProps, file: any) => {
  const form = new FormData();

  form.append('file', file);
  form.append('id', formValues.id || '');
  form.append('numero', formValues.numero.toString());
  form.append('revisao', formValues.revisao.toString());
  form.append('observacao', formValues.observacao || '');
  form.append('dataAprovacao', String(formValues.dataAprovacao));

  return api.post<CrfPlanilhaOrcadoEconomico>(`${controller}/planilha/orcadoAnual`, form, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const updateCrfPlanilhaOrcadoEconomicoAnoMes = (formValues: CrfPlanilhaOrcadoEconomicoFormProps) =>
  api.put<CrfPlanilhaOrcadoEconomico>(`${controller}/planilha/orcadoAnual/${formValues.id}`, formValues);

export const getAllResumoCrfPlanilhaAnoProjeto = (projetoId: any) =>
  api.get<CrfResumoAnoMes>(`${controller}/${projetoId}/planilha/orcadoAnual/resumo`);
//#endregion

export const getAllCrfProjetoContaContabilCc = (projeto: string = '', pacoteOi: string = '') =>
  api.get<any[]>(
    `${controller}/getAllProjetoCrfContaContabilCc?projeto=${projeto}&pacoteOi=${pacoteOi}`,
  );

export const getAllCrfProjetoContaContabilCcRelatorioCentroDeCustoForcast = () => {
  return api.get<IRelatorioCentroDeCustoResult[]>(`${controller}/relatorio/CentroDeCusto/forcastAno`);
}
export const getAllCrfProjetoContaContabilCcRelatorioCentroDeCusto = () => {
  return api.get<IRelatorioCentroDeCustoResult[]>(`${controller}/relatorio/CentroDeCusto`);
}
export const exportarCrfProjetoContaContabilCcRelatorioCentroDeCusto = () => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/crfExportar/relatorio/CentroDeCusto`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "Relatório Centro de Custo - Conta Contábil.xlsx");
      link.setAttribute('id', 'relatorio-centro-de-custo-conta-contabil');
      document.body.appendChild(link);
      link.click();

      let element = document.getElementById('relatorio-centro-de-custo-conta-contabil');
      if (element) {
        element.outerHTML = '';
      }
    }),
  );
}

export const exportarCrfProjetoContaContabilCcRelatorioCentroDeCustoForcast = () => {
  const urlBase = window.location.origin;

  trackPromise(
    Axios.get(`${urlBase}/api/crfExportar/relatorio/CentroDeCusto/forcast`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', "Relatório Centro de Custo - Conta Contábil.xlsx");
      link.setAttribute('id', 'relatorio-centro-de-custo-conta-contabil');
      document.body.appendChild(link);
      link.click();

      let element = document.getElementById('relatorio-centro-de-custo-conta-contabil');
      if (element) {
        element.outerHTML = '';
      }
    }),
  );
}

export const getAllCrfProjetoRelatorioRpp = () =>
  api.get<CrfProjeto[]>(`${controller}/relatorio/Rpp`);
